import React from "react";

import { FaInfoCircle } from "react-icons/fa";
import { IconWrapper, InfoContainer, InfoWrapper, Tooltip } from "./styles";
import { createStyledIcon } from "utils/iconUtils";

interface InfoProps {
  details: React.ReactNode;
}

const InfoCircleIcon = createStyledIcon(FaInfoCircle);

export const Info: React.FC<InfoProps> = ({ details }) => {
  return (
    <InfoContainer>
      <InfoWrapper>
        <IconWrapper>
          <InfoCircleIcon size={20} />
        </IconWrapper>
        <Tooltip role="tooltip">{details}</Tooltip>
      </InfoWrapper>
    </InfoContainer>
  );
};
